import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    IconLayoutDashboard,
    IconBuildingSkyscraper,
    IconCreditCard,
    IconUsers,
    IconLock,
} from '@tabler/icons-react';
import styles from './PropertyManagerSidebar.module.css';

const NAV_ITEMS = [
    {
        label: 'Dashboard',
        path: '/property-manager',
        icon: IconLayoutDashboard,
        exact: true,
    },
    {
        label: 'Portfolio',
        path: '/property-manager/portfolio',
        icon: IconBuildingSkyscraper,
    },
    {
        label: 'Billing & Payments',
        path: null,
        icon: IconCreditCard,
        disabled: true,
        badge: 'Coming Soon',
    },
    {
        label: 'User Management',
        path: null,
        icon: IconUsers,
        disabled: true,
        badge: 'coming Soon',
    },
];

const PropertyManagerSidebar = ({ companyName }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (item) => {
        if (item.exact) return location.pathname === item.path;
        return location.pathname.startsWith(item.path);
    };

    return (
        <aside className={styles.sidebar}>
            <div className={styles.logoArea}>
                <div>
                    <div className={styles.logoText}>{companyName || 'Management Portal'}</div>
                </div>
            </div>

            <nav className={styles.nav}>
                {NAV_ITEMS.map((item) => {
                    const Icon = item.icon;
                    const active = !item.disabled && isActive(item);

                    return (
                        <button
                            key={item.label}
                            className={[
                                styles.navItem,
                                active ? styles.navItemActive : '',
                                item.disabled ? styles.navItemDisabled : '',
                            ].join(' ')}
                            onClick={() => !item.disabled && item.path && navigate(item.path)}
                            disabled={item.disabled}
                        >
                            <div>
                                <Icon
                                    size={18}
                                    className={styles.navIcon}
                                    stroke={1.8}
                                />
                                <span className={styles.navLabel}>{item.label}</span>
                                {item.disabled && (
                                    <IconLock size={14} className={styles.lockIcon} stroke={1.8} />
                                )}
                            </div>
                            <div>
                                {item.badge && (
                                    <span className={styles.navBadge}>{item.badge}</span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </nav>
        </aside>
    );
};

export default PropertyManagerSidebar;
